import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useData } from '../context/DataContext';
import './Sidebar.css';

const Sidebar = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const { categories, loading, isUsingSupabaseData } = useData();
  
  const filteredCategories = categories.filter(category =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Calculate total items across all categories
  const totalItems = categories.reduce((total, category) => total + category.items.length, 0);

  if (loading) {
    return (
      <div className="sidebar">
        <div className="search-container">
          <input
            type="text"
            placeholder="Loading categories..."
            disabled
            className="search-input"
          />
        </div>
        <div style={{ padding: '20px', textAlign: 'center' }}>
          Loading...
        </div>
      </div>
    );
  }

  return (
    <div className="sidebar">
      <div className="search-container">
        <input
          type="text"
          placeholder="Search categories..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
      </div>
      <nav className="category-nav">
        <ul className="category-list">
          <li>
            <Link to="/category/all" className="category-item all-items">
              All Items
              <span className="item-count">{totalItems}</span>
            </Link>
          </li>
          {filteredCategories.map((category) => (
            <li key={category.id}>
              <Link to={`/category/${category.id}`} className="category-item">
                {category.name}
                <span className="item-count">{category.items.length}</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar; 